import React from 'react';
import { mdiCheck, mdiContentCopy } from '@mdi/js';
import Icon from '@mdi/react';
import { snackbar } from 'components/notifications/notifications';
import { useState } from 'react';

const copyToClipboard = (text, options = {}) => {
  const { showNotification = true, notificationText = null, callback = null } = options;
  navigator.clipboard.writeText(text);
  showNotification && snackbar(notificationText ?? `"${text}" copied to clipboard`, 'success');
  callback && callback(text);
};

export const CopyToClipboard = (props) => {
  const [copied, setCopied] = useState(false);
  const {
    text = '',
    notificationText = null,
    showNotification = true,
    copyAgain = true,
    waitTimeout = 2000,
    ...rest
  } = props;

  const handleClick = () => {
    copyToClipboard('text to copy', {
      showNotification: true,
      notificationText: notificationText,
      callback: function () {
        setCopied(true);

        if (copyAgain) {
          setTimeout(() => {
            setCopied(false);
          }, waitTimeout);
        }
      },
    });
  };

  return (
    <Icon
      className='cursor-pointer'
      path={copied ? mdiCheck : mdiContentCopy}
      {...rest}
      onClick={handleClick}
    />
  );
};

export default copyToClipboard;
